module.exports = __webpack_public_path__ + "media/images/education/avatar-orsolya-adfb10d06eff579f9a1c387d44021138.png";